import { passkeysGateway } from "@/gateways/passkeysGateway";
import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
import { usePasskeyRegistration } from "./usePasskeyRegistration";

export function useListPasskeys() {
  const query = useQuery({
    queryKey: ["passkeys"],
    queryFn: () => passkeysGateway.listPasskeys(),
  });

  return { ...query, listPasskeysStatus: query.status, passkeys: query.data };
}

export function useRegisterPasskey() {
  const queryClient = useQueryClient();
  const registerPasskey = usePasskeyRegistration();
  const mutation = useMutation({
    mutationFn: registerPasskey,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["passkeys"] }),
  });

  return {
    ...mutation,
    registerPasskey: mutation.mutate,
    registerPasskeyStatus: mutation.status,
  };
}

export function useDeletePasskey() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (id: string) => passkeysGateway.deletePasskey(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["passkeys"] }),
  });

  return {
    ...mutation,
    deletePasskey: mutation.mutate,
    deletePasskeyStatus: mutation.status,
  };
}
